import { render, staticRenderFns } from "./document-tabs.vue?vue&type=template&id=666e1f51&scoped=true"
import script from "./document-tabs.vue?vue&type=script&lang=js"
export * from "./document-tabs.vue?vue&type=script&lang=js"
import style0 from "./document-tabs.vue?vue&type=style&index=0&id=666e1f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e1f51",
  null
  
)

export default component.exports